import {makeStyles} from "@mui/styles";
import styles from "../theme/styles";

export const useStyles = makeStyles(styles, {withTheme: true});
